module.exports = __webpack_public_path__ + "static/media/JP_RC_EYELASHES01.d70dd21f.jpg";